import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { privacyRightsOptions } from 'legal/constants/privacyRightsOptions'
import { useMemo } from 'react'

export function usePrivacyRightsOptions() {
	const { t } = useLabels()

	return useMemo(
		() =>
			privacyRightsOptions.map((option) => ({
				value: option,
				content: t(option),
			})),
		[t]
	)
}
